<template>
  <div class="dashboard-container" id="food-app">
    <div class="container">
      <div class="tableBar">
        <el-input
          v-model="input"
          placeholder="请输入优惠券名称"
          style="width: 250px"
          clearable
          @keyup.enter="handleQuery"
        >
          <i
            slot="prefix"
            class="el-input__icon el-icon-search"
            style="cursor: pointer"
            @click="init"
          ></i>
        </el-input>

        <el-button type="danger" @click="sousuo"> 搜索</el-button>

        
        <el-button type="primary" @click="addGONG"> 新增</el-button>



      </div>



      <el-table
        :data="tableData"
        stripe
        class="tableBox"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="25"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="优惠券序号"
        ></el-table-column>
        <el-table-column
          prop="youName"
          label="优惠券名称"
        ></el-table-column>
        <el-table-column
          prop="discount"
          label="优惠券折扣"
        ></el-table-column>
        <el-table-column
        prop="image"
        label="优惠券照片"
      >
      <template #default="scope">
      <img 
        :src="scope.row.image"
        style="width: 250px; height: 120px;" 
      />
    </template>
      </el-table-column>
   
        <el-table-column
          prop="passTime"
          label="优惠券过期时间"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          width="160"
          align="center"
        >
          <template #default="scope">
            <el-button
              type="primary"
              size="small"
              style="margin-bottom: 10px;margin-left: 10px;"
              class="delBut non"
              @click="changeHandle(scope.row)"
              icon="el-icon-delete"
            >
              修改
            </el-button>
            <el-button
              type="danger"
              size="small"
              class="delBut non"
              @click="deleteHandle(scope.row.id)"
              icon="el-icon-delete"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pageList"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="counts"
        @size-change="handleSizeChange"
        v-model:current-page="page"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog title="优惠券信息" v-model="dialogTableVisible">
      <el-form label-width="180px" :model="adminmsg">
        <el-form-item label="优惠券序号:" style="width: 800px">
          <el-input disabled v-model="adminmsg.id" readonly></el-input>
        </el-form-item>
        <el-form-item label="优惠券名称:" style="width: 800px">
          <el-input  v-model="adminmsg.youName" ></el-input>
        </el-form-item>
        <el-form-item label="折扣价:" style="width: 800px">
          <el-input  v-model="adminmsg.discount" type="number"></el-input>
        </el-form-item>
        <el-form-item label="优惠券过期时间:" style="width: 800px">
  <el-date-picker
    v-model="adminmsg.passTime"
    type="datetime"
    placeholder="选择日期时间"
    format="yyyy-MM-dd HH:mm:ss"
    value-format="yyyy-MM-dd HH:mm:ss"

    :clearable="false">
  </el-date-picker>
</el-form-item>
          
    <el-form-item label="优惠券图片:" style="width: 800px">
        <!-- 图片预览 -->
        <div v-if="adminmsg.image" class="preview-image">
          <img :src="adminmsg.image" alt="优惠券图片" style="max-width:100%; height: auto;" />
          <el-button type="danger" icon="el-icon-delete" circle @click="removeImage"></el-button>
        </div>
        <!-- 文件上传 -->
        <el-upload
          v-if="!adminmsg.image"
          action="http://localhost:8090/file/upload"
          :on-success="handleUploadSuccess"
          list-type="picture-card"
          :limit="1"
          :on-remove="handleRemove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogTableVisible = false">取 消</el-button>
    <el-button type="primary" @click="quedingedit(adminmsg)">确 定</el-button>
  </span>
    </el-dialog>


  </div>


</template>

<script>
import axios from "axios";





export default {
  name: 'Manage',
  data() {
    return {
      tableData: [],
      typeNameArr: [],
      pagesize:10,
      page:1,
      input: '',
      zhuangtai: '',
       dialogImageUrl: '', // 对话框中显示的图片URL
    dialogVisible: false, // 控制图片预览对话框的显示/隐藏
      counts:0,
      msg:"",
      dialogTableVisible:false,
      adminmsg:{
         id:'',
        image:'',
        discount:'',
        youName:'',
        passTime:'',
      },
    }
  },



  mounted() {
    this.init()
  },
  methods: {

    init(){
      const params = {
        page: this.page,
        pagesize: this.pagesize,
        input: this.input ? this.input : undefined
      }
      axios.get('http://localhost:8090/mer/getMyDiscount',{
          params
        }
      )
        .then(response => {

          this.tableData=response.data.data.records
          this.counts=response.data.data.total
          // 请求成功时的处理逻辑
          console.log(this.tableData)

        })
        .catch(error => {
          // 请求失败时的处理逻辑
          console.error(error); // 输出错误信息
        });
    },

    //点击搜索执行方法即可
    sousuo(){
      this.init();

    },

     // 文件上传前的钩子函数
  beforeUpload(file) {
    const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJPGOrPNG) {
      this.$message.error('只能上传 JPG 或 PNG 格式的图片!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      this.$message.error('图片大小不能超过 2MB!');
    }
    return isJPGOrPNG && isLt2M;
  },

  // 文件移除时的回调
  handleRemove(file, fileList) {
    this.adminmsg.image = ''; // 清空图片URL
  },

  handleUploadSuccess(response){

this.adminmsg.image=response.data
},

  // 点击缩略图时打开图片预览对话框
  handlePictureCardPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  },

    getDormTypeLabel(type) {
    switch (type) {
      case 0:
        return '女生';
      case 1:
        return '男生';
      default:
        return '未知';
    }
  },


  getDormStatusLabel(status) {
    switch (status) {
      case 0:
        return '开启';
      case 1:
        return '关闭';
      default:
        return '未知';
    }
  },
    
    addGONG(){
      this.adminmsg={}
      this.msg="新增"
      this.dialogTableVisible=!this.dialogTableVisible
    },

    removeImage() {
   
      this.adminmsg.image = '';
     

  },
//打开修改窗口
changeHandle(data){
   this.adminmsg=data
   this.msg="修改"
      this.dialogTableVisible=!this.dialogTableVisible
    },

    quedingedit(data){
      this.zhuangtai="good"
    if(this.msg=="修改"){
      this.$confirm('确认修改优惠券信息, 是否继续?', '确定修改', {
  'confirmButtonText': '确定',
  'cancelButtonText': '取消',
}).then(()=>{
  axios.post('http://localhost:8090/discount/update',data)
    .then(response => {
      // 请求成功时的处理逻辑
      this.$message.success("修改成功！")
      this.dialogTableVisible=false
          this.init();
    })
    .catch(error => {
      // 请求失败时的处理逻辑
      console.error(error); // 输出错误信息
    });
})
    }
else{
this.$confirm('确认新增优惠券信息, 是否继续?', '确定新增', {
  'confirmButtonText': '确定',
  'cancelButtonText': '取消',
}).then(()=>{
  axios.post('http://localhost:8090/mer/addDiscount',data)
    .then(response => {
      // 请求成功时的处理逻辑
      this.$message.success("新增成功！")
      this.dialogTableVisible=false
      this.init();
    })
    .catch(error => {
      // 请求失败时的处理逻辑
      console.error(error); // 输出错误信息
    });
})
} 
},




    addFoodtype(){
      console.log(666)
    },
    handleQuery(){
      console.log(666)
    },


    deleteHandle(data){
      this.$confirm('确认删除该优惠券信息, 是否继续?', '确定删除', {
        'confirmButtonText': '确定',
        'cancelButtonText': '取消',
      }).then(()=>{
        axios.delete('http://localhost:8090/discount/delete?id='+data)
          .then(response => {
            // 请求成功时的处理逻辑
            this.$message.success("删除成功！")
            this.dialogTableVisible=false
          this.init();
          })
          .catch(error => {
            // 请求失败时的处理逻辑
            console.error(error); // 输出错误信息
          });
      })
    },
    // 全部操作
    handleSelectionChange (val){
      let checkArr = []
      val.forEach((n) => {
        checkArr.push(n.id)
      })
      this.checkList = checkArr
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange (val) {
      this.page = val
      this.init()
    }

  }
}
</script>

<style lang="less" scoped>
.manage {
  padding: 16px;
}
</style>
